<template>
  <div class="col-sm-12 cart-coupon" v-bind:class="className">
    <div
      class="row"
      v-if="!hiddenCouponInputs"
      :style="showNewUiMobile && 'width : 100vw'"
    >
      <div :class="getCSSInput">
        <input
          type="text"
          class="form-control coupon-text"
          :style="showNewUiMobile && 'margin-left: -8px'"
          v-model="CouponCode"
          :placeholder="getDiscountlang"
          @keydown.enter.prevent
        />
        <img
          @click="openScanner()"
          v-if="isMobile()"
          class="qrscanner-icon"
          :class="isMobile() && 'coupon-scanner-icon'"
          src="../../../../src/assets/qrcode-icon.png"
          alt="Qr code scanner"
        />
      </div>
      <div :class="getCSSBtn">
        <button
          type="button"
          :disabled="proccessing"
          class="btn btn-primary w-85 d-flex justify-content-center"
          :style="btnStyle"
          @click="ApplyCoupon"
        >
          <span v-show="proccessing">
            <i class="spin-sm" />
          </span>
          <span
            v-show="!proccessing && isMobile() && !this.isRolldStore()"
            class="material-icons m-0"
            >forward</span
          >
          {{ getApplyText }}
        </button>
      </div>
    </div>
    <div class="row" v-if="!hiddenCouponInputs">
      <div class="col-sm-12 color-red">{{ getCouponMessage }}</div>
    </div>
    <div
      class="coupons-countauner"
      :class="{ 'coupons-countainer-margin': hiddenCouponInputs }"
      v-if="CurrentCoupons.length"
    >
      <div class="coupon-validated">
        <span
          class="coupon-code"
          :class="{
            used:
              used_coupons
                .map((c) => {
                  return c.coupon.CouponCode;
                })
                .indexOf(couponItem.CouponCode) > -1 ||
              giftUsedCoupons
                .map((c) => {
                  return c.coupon.CouponCode;
                })
                .indexOf(couponItem.CouponCode) > -1,
          }"
          :title="
            used_coupons
              .map((c) => {
                return c.coupon.CouponCode;
              })
              .indexOf(couponItem.CouponCode) > -1 ||
            giftUsedCoupons
              .map((c) => {
                return c.coupon.CouponCode;
              })
              .indexOf(couponItem.CouponCode) > -1
              ? 'Used'
              : 'unused'
          "
          v-for="(couponItem, index) in CurrentCoupons"
          :key="index"
        >
          <img class="coupon-image" :src="ImgInfo" alt="ImgInfo" />
          {{ couponItem.CouponCode }}
          <span
            class="remove-coupon"
            @click="remove_coupon(couponItem.CouponCode)"
            title="remove"
            >X</span
          >
        </span>
      </div>
    </div>
    <div class="col-sm-12 cart-coupon" v-bind:class="className">
      <span
        class="text-danger"
        v-show="
          (isGift && giftDiscount == 0 && CurrentCoupons.length > 0) ||
          (!isGift && couponDiscount == 0 && CurrentCoupons.length > 0)
        "
        >{{ $t("message.couponDoesNotApplyToAnyItems") }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { logger } from "../../../api/Logger";
import { CouponServiceApi } from "../../../api/services/couponService.js";
export default {
  name: "CouponComponent",
  components: {},
  props: {
    backToGiftCart: {
      type: Boolean,
      required: false,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
    ForMobile: {
      type: Boolean,
      default: false,
    },
    qrcode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      CouponCode: "",
      CouponMessage: "",
      proccessing: false,
    };
  },
  mounted() {
    if (this.qrcode && this.qrcode.length > 0) {
      this.applyCoupon(this.qrcode);
    }
  },
  computed: {
    ...mapGetters([
      "used_coupons",
      "getApplyMultiCoupon",
      "discount",
      "mobileStyles",
      "desktopStyles",
      "isGift",
      "giftCoupons",
      "coupons",
      "couponDiscount",
      "viewConfig",
      "showNewUi",
    ]),
    getDiscountlang() {
      return this.showNewUi
        ? this.$t("message.discountCoupon")
        : this.$t("message.discountCode");
    },
    getCouponMessage() {
      if (this.CouponMessage == "Coupon code not found")
        return this.$t("message.CouponNotFound");
      else if (this.CouponMessage == "enterCode")
        return this.$t("message.pleaseEnterTheDiscountCode");
      else {
        return this.CouponMessage;
      }
    },
    isChromeIos() {
      return navigator.userAgent.match("CriOS");
    },
    giftUsedCoupons: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftUsedCoupons"];
      },
    },
    giftDiscount: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftDiscount"];
      },
    },
    CurrentCoupons() {
      return this.isGift
        ? this.$store.getters["newGiftShoppingCart/giftCoupons"]
        : this.coupons;
    },

    ImgInfo() {
      return require("../../../assets/Tag.png");
    },
    getApplyText() {
      return (this.ForMobile && !this.isRolldStore()) || this.proccessing
        ? ""
        : this.$t("message.apply");
    },

    getCSSInput() {
      let id = 8;
      return this.ForMobile ? "col-" + id : "col-sm-" + id;
    },

    getCSSBtn() {
      let id = 4;
      let style = this.ForMobile ? `col-${id} ` : "col-sm-" + id;

      return style;
    },
    hiddenCouponInputs() {
      return !this.getApplyMultiCoupon && this.CurrentCoupons.length > 0;
    },
    btnStyle() {
      if (this.ForMobile) {
        return {
          ...this.mobileStyles.btn,
          width: this.showNewUi && "90% !important",
        };
      }
      return {
        ...this.desktopStyles.btn,
      };
    },
    CouponMsg() {
      return this.CouponMessage;
    },
    showNewUiMobile() {
      return this.showNewUi && this.ForMobile;
    },
  },
  methods: {
    ...mapActions(["addCouponToCart", "removeCouponfromCart"]),
    openScanner() {
      this.$router.push({
        name: "qrCodeScanner",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
          backToGiftCart: this.backToGiftCart,
        },
      });
    },
    applyCoupon(code) {
      this.CouponCode = code;
      this.ApplyCoupon();
    },
    remove_coupon(coupon) {
      if (this.isGift)
        this.$store.dispatch(
          "newGiftShoppingCart/removeCouponfromCart",
          coupon
        );
      else this.removeCouponfromCart(coupon);
    },

    ApplyCoupon() {
      this.CouponMessage = "";
      var that = this;
      this.proccessing = true;
      if (!this.CouponCode || !this.CouponCode.trim()) {
        that.CouponMessage = "enterCode";
        that.proccessing = false;
        return;
      }
      const storeId = this.$route.params.storeid;
      CouponServiceApi.IsValidated(this.CouponCode, storeId)
        .then((response) => {
          if (response.data.Success) {
            var coupon = response.data.Coupon;
            that.$store.dispatch(`newGiftShoppingCart/addCouponToCart`, {
              coupon,
              storeId,
            });
            that.addCouponToCart({ coupon, storeId });
            that.CouponCode = "";

            if (this.showNewUi && this.viewConfig.EnableConfetti) {
              // show success confetti

              this.$confetti.start();
              setTimeout(() => {
                this.$confetti.stop();
              }, 2500);
            }
            this.$emit("closeModal");
          } else {
            that.CouponMessage = response.data.Status.Message;
          }

          that.proccessing = false;
        })
        .catch((error) => {
          that.CouponMessage = "unknown error in coupon validating";
          that.proccessing = false;
          logger.log(
            "coupon",
            error.message,
            that.$router.currentRoute.fullPath
          );
        });
    },
    CouponMessageMapper(Status) {
      switch (Status.Tag) {
        case "COUPON_NOT_FOUND":
          return this.getCouponCodeNotFound;
        default:
          return Status.Message;
      }
    },
  },
};
</script>
